var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("a", {
    className: "icon-link"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.35 6.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M212 64h24v24h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 64h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 -56.092 -16.933)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m234.683 73.394-1.88-.239a9.5 9.5 0 0 0-.569-1.374l1.161-1.495a1.486 1.486 0 0 0-.122-1.979l-1.575-1.575a1.49 1.49 0 0 0-1.985-.127l-1.493 1.161a9.4 9.4 0 0 0-1.375-.569l-.239-1.877A1.5 1.5 0 0 0 225.12 64h-2.24c-.757 0-1.396.567-1.486 1.317l-.239 1.88a9.3 9.3 0 0 0-1.375.569l-1.494-1.161a1.49 1.49 0 0 0-1.979.122l-1.575 1.574a1.49 1.49 0 0 0-.127 1.986l1.161 1.494a9.3 9.3 0 0 0-.569 1.374l-1.877.239c-.753.09-1.32.729-1.32 1.486v2.24c0 .757.567 1.396 1.317 1.486l1.88.239q.234.717.569 1.374l-1.161 1.495a1.486 1.486 0 0 0 .122 1.979l1.575 1.575a1.49 1.49 0 0 0 1.985.126l1.494-1.161q.657.337 1.374.569l.239 1.876c.09.755.729 1.322 1.486 1.322h2.24c.757 0 1.396-.567 1.486-1.317l.239-1.88a9.5 9.5 0 0 0 1.374-.569l1.495 1.161c.605.47 1.459.415 1.979-.122l1.575-1.575a1.49 1.49 0 0 0 .127-1.985l-1.161-1.494q.337-.657.569-1.374l1.876-.239a1.5 1.5 0 0 0 1.32-1.486v-2.24a1.496 1.496 0 0 0-1.316-1.486M224 81c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.6462c98f41912864d69bbc67c4ebcb93.svg";
export { ForwardRef as ReactComponent };